/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ModuleUpgradeOffer } from './moduleUpgradeOffer';

export type ModuleUpgradeOfferProperty = ModuleUpgradeOffer | null;
